import { combineReducers, configureStore } from '@reduxjs/toolkit'

import { bookMeetingModalReducer } from '@/redux/slices/bookMeetingModal'
import { clientMetadataReducer } from '@/redux/slices/clientMetadata'
import { clientPortalReducer } from '@/redux/slices/clientPortal'
import { clientsReducer } from '@/redux/slices/clients'
import { commercialAgreementsFormReducer } from '@/redux/slices/commercialAgreementsForm'
import { commercialAgreementsMetadataReducer } from '@/redux/slices/commercialAgreementsMetadata'
import { commercialAgreementsModalReducer } from '@/redux/slices/commercialAgreementsModal'
import { commercialAgreementTemplateReducer } from '@/redux/slices/commercialAgreementTemplateReview'
import { commonDataReducer } from '@/redux/slices/commonData'
import { companyReducer } from '@/redux/slices/company'
import { compassReducer } from '@/redux/slices/compass'
import { compassClientsReducer } from '@/redux/slices/compassClients'
import { compassPdfGuideReducer } from '@/redux/slices/compassPdfGuideData'
import { completeRegistrationPopupReducer } from '@/redux/slices/completeRegistrationPopup'
import { globalSearchReducer } from '@/redux/slices/globalSearch'
import { icaewModalsReducer } from '@/redux/slices/icaewModals'
import { inviteToRqModalReducer } from '@/redux/slices/inviteToRqModal'
import { layoutReducer } from '@/redux/slices/layout'
import { logHistoricalReferralReducer } from '@/redux/slices/logHistoricalReferral'
import { onboardingChecklistReducer } from '@/redux/slices/onboardingChecklist'
import { outlookReferralReducer } from '@/redux/slices/outlookReferral'
import { panelReducer } from '@/redux/slices/panel'
import { panelInviteReducer } from '@/redux/slices/panelInvite'
import { paymentsReducer } from '@/redux/slices/payments'
import { referralApprovalRequestReducer } from '@/redux/slices/referralApprovalRequest'
import { referralCaseReducer } from '@/redux/slices/referralCase'
import { referralLinkReducer } from '@/redux/slices/referralLink'
import { referralsReducer } from '@/redux/slices/referrals'
import { referralESignatureConsentPdfReducer } from '@/redux/slices/referralSignatureConsentPdf'
import { referralsImportHistoricalReducer } from '@/redux/slices/referralsImportHistorical'
import { referralsImportNewReducer } from '@/redux/slices/referralsImportNew'
import { referralStatusesReducer } from '@/redux/slices/referralStatuses'
import { relationshipSetupReducer } from '@/redux/slices/relationshipSetup'
import { sessionReducer } from '@/redux/slices/session'
import { demoVideoReducer } from '@/redux/slices/videoModal'
import { webReferralReducer } from '@/redux/slices/webReferral'

const rootReducer = combineReducers({
  bookMeetingModal: bookMeetingModalReducer,
  clientMetadata: clientMetadataReducer,
  clientPortal: clientPortalReducer,
  completeRegistrationPopup: completeRegistrationPopupReducer,
  layout: layoutReducer,
  clients: clientsReducer,
  commonData: commonDataReducer,
  commercialAgreementsMetadata: commercialAgreementsMetadataReducer,
  commercialAgreementsForm: commercialAgreementsFormReducer,
  commercialAgreementTemplateReview: commercialAgreementTemplateReducer,
  commercialAgreementsModal: commercialAgreementsModalReducer,
  compass: compassReducer,
  compassClients: compassClientsReducer,
  compassPdfGuide: compassPdfGuideReducer,
  company: companyReducer,
  demoVideo: demoVideoReducer,
  globalSearch: globalSearchReducer,
  icaewModals: icaewModalsReducer,
  inviteToRqModal: inviteToRqModalReducer,
  outlookReferral: outlookReferralReducer,
  logReferral: logHistoricalReferralReducer,
  panel: panelReducer,
  panelInvite: panelInviteReducer,
  payments: paymentsReducer,
  onboardingChecklist: onboardingChecklistReducer,
  referrals: referralsReducer,
  referralApprovalRequest: referralApprovalRequestReducer,
  referralCase: referralCaseReducer,
  referralsImportHistorical: referralsImportHistoricalReducer,
  referralsImportNew: referralsImportNewReducer,
  referralSignatureConsentPdf: referralESignatureConsentPdfReducer,
  referralStatuses: referralStatusesReducer,
  referralLink: referralLinkReducer,
  relationshipSetup: relationshipSetupReducer,
  session: sessionReducer,
  webReferral: webReferralReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

store.subscribe(() => {
  const state = store.getState()
  window.RQ = window.RQ || {}
  window.RQ.store = state
})
